// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { GalleryItem } from "../item/GalleryItem";

@Component({
  mixins: [template],
  components: {
    GalleryItem,
  },
})
export class WeightedRowFour extends Vue {
  @Prop()
  public images!: object[];

  @Prop()
  public lang!: string;
}
